export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN || 'your-app.auth0.com',
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || 'your-client-id',
  redirectUri: window.location.origin,
};